
import { BOOKINGFLIGHT, CANCELBOOKINGFLIGHT } from "./actionTypes";

export const addBookingFlight = (value) => {
    return {
        type: BOOKINGFLIGHT,
        payload: value
    };
};

export const cancelBookingFlight = (value) => {
    return {
        type: CANCELBOOKINGFLIGHT,
        payload: value
    };
};
